import { useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom'
import { Box, Center, Spinner } from '@chakra-ui/react'

import api from '@/api'

export const RecordingOptOut = () => {
  const { optoutId } = useParams()
  const navigate = useNavigate()
  const [isOptedOut, setIsOptedOut] = useState(false)

  if (!optoutId) {
    navigate('/')
    return null
  }

  useEffect(() => {
    const handleOptOut = async () => {
      if (optoutId !== 'test_id') {
        await api.recordingOptOut(optoutId)
      }
      setIsOptedOut(true)
    }
    handleOptOut()
  }, [optoutId])

  return (
    <Center h="100vh">
      <Box>
        {isOptedOut ? 'You have been opted out of recording.' : <Spinner />}
      </Box>
    </Center>
  )
}
